import supabaseClient from '@/api/supabaseClient.ts';
import { SchoolRepository as SharedSchoolRepository } from '$/repositories/schoolRepository/SchoolRepository.ts';

const schoolRepository = new SharedSchoolRepository(supabaseClient);
export default schoolRepository;
